export default "__VITE_ASSET__D5bJX0Og__"